import { useEffect, useRef } from 'react'

/**
 * Diz se o componente ainda está montado.
 *
 * Existe para os passos do segundo fator. Ali o caminho FELIZ desmonta a tela:
 * o código certo cria a sessão, o `AuthProvider` troca o login pelo layout do
 * sistema, e o `setSubmitting(false)` que o Formik roda logo em seguida cai num
 * componente que não existe mais — React avisa "Can't perform a React state
 * update on an unmounted component" no console.
 *
 * O mesmo vale para as recusas que devolvem ao passo de e-mail/senha
 * (`MFA_CHALLENGE_GONE`, 429): o passo some e o `finally` ainda tem de rodar
 * para o caso em que ele CONTINUA na tela (código inválido com tentativas
 * restantes), que é justamente quando o botão precisa voltar a abrir.
 *
 * Por isso a trava é um ref lido na hora, e não um `if` no caminho feliz: o
 * componente não tem como saber de antemão qual dos desfechos vai desmontá-lo.
 */
export function useIsMounted(): () => boolean {
  const mounted = useRef(true)

  useEffect(() => {
    mounted.current = true

    return () => {
      mounted.current = false
    }
  }, [])

  return () => mounted.current
}
